// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';

export const Legend: React.FC = () => {
  return (
    <div className="legend" aria-hidden="true">
      <span className="chip" style={{color:"var(--dt-node-decision)"}}>
        <span className="sw" /> Decision
      </span>
      <span className="chip" style={{color:"var(--dt-node-chance)"}}>
        <span className="sw" style={{borderRadius:"999px"}}/> Chance
      </span>
      <span className="chip" style={{color:"var(--dt-node-terminal)"}}>
        <span className="sw sw-terminal" style={{
          clipPath: "polygon(0 100%, 0 0, 100% 50%)",
          background: "var(--dt-node-terminal)",
          border: "none",
          opacity: 0.85
        }}/>
        Terminal
      </span>
    </div>
  );
};

